import styled, { keyframes } from 'styled-components'

import { helpers } from 'styles'

const dash = keyframes`
	0% {
		stroke-dashoffset: 70;
		transform: rotate(-180deg);
	}

	40% {
		stroke-dashoffset: 90;
	}

	100% {
		stroke-dashoffset: 70;
		transform: rotate(180deg);
	}
`

export const PrimaryCircle = styled.circle`
	animation: 0.8s linear infinite both ${dash};
	fill: transparent;
	stroke: ${helpers.color.spinnerPrimary};
	stroke-dasharray: 100;
	stroke-linecap: round;
	transform-origin: 50% 50%;
`
